import React, { Component } from 'react';
import hydrationMask from 'assets/icons/hydration/hydration_mask.png';

class HydrationDayProgressPreloader extends Component {
    render() {
        return (
            <div className="text-center">
                <div className="drop">
                    <img src={hydrationMask} className="img-fluid" alt="" />
                </div>
            </div>
        );
    }
}

export default HydrationDayProgressPreloader;
